//
// FieldLayoutBuilder
//
// Based on view info from a layout

import { observer } from 'mobx-react-lite'
import { useStore } from '../../../../stores'

import { TypedField } from '.'
import { Text } from '../../../../components'
import { LAYOUTCOMPONENTTYPECONFIG } from '../../../../stores/data/LAYOUTCOMPONENTTYPECONFIG'
import { FieldLabel, FieldMetadata, LabeledField } from '../fields'

export const FieldLayoutBuilder = observer(function FieldLayoutBuilder({
    className,
    component,
    components,
    layout,
    record,
    worksheet,
    active_class,
    visited_gids,
    force_readonly,
}) {
    const store = useStore()

    const config = LAYOUTCOMPONENTTYPECONFIG['field']

    const field_gid = component.field
    const placeholder = component.placeholder

    let field = worksheet.findField(field_gid)
    if (!field) {
        return null
    }
    const fromClass = worksheet.findClassForField(null, field)

    const editable = force_readonly
        ? false
        : 'editable' in component
          ? component.editable
          : config.editable.default
    const localizedPlaceholder = placeholder && placeholder[store.appLanguage]

    const Placeholder = localizedPlaceholder ? (
        <div className="ws-placeholder">{localizedPlaceholder}</div>
    ) : undefined

    let attributes = { className: 'layout-component' }
    if (className) attributes['className'] += ' ' + className
    if (component.style) attributes['className'] += ' lc-' + component.style
    if (component.gid === worksheet.layoutstore.selectedComponentGid) {
        attributes['className'] += ' cc-selected'
    }
    // attributes["onClick"] = e => onClickElement(e, component, layouttreestore)

    const Field = (
        <TypedField
            field={field}
            fromClass={fromClass}
            component={component}
            editable={editable}
            force_readonly={force_readonly}
            record={record}
            active_class={active_class}
            worksheet={worksheet}
            visited_gids={visited_gids}
        />
    )

    const fieldvalue =
        record.localized_fields && record.localized_fields.get(field.name)
    if (fieldvalue === undefined) {
        return (
            <LabeledField
                fieldgid={field.gid}
                label={<FieldLabel field={field} worksheet={worksheet} />}
                fromClass={fromClass}
                worksheet={worksheet}
                {...attributes}
            >
                <Text>
                    {store.app.text("Undefined field '{fieldname}'", {
                        fieldname: field.name,
                    })}
                </Text>
            </LabeledField>
        )
    }

    if (
        field.type !== 'boolean' &&
        (fieldvalue === null || !fieldvalue.toString().length)
    ) {
        attributes['className'] += ' ws-placeholder-visible'
        if (
            [
                'textlist',
                'record',
                'recordlist',
                'file',
                'filelist',
                'image',
                'imagelist',
                'class',
                'classlist',
                'fieldpicker',
            ].includes(field.type)
        ) {
            attributes['className'] += ' ws-placeholder-with-field'
        }
    }

    let BelowLabel
    let BelowField
    if (component.metadata) {
        BelowLabel = [...component.metadata].map(([name, value], index) => {
            return value === 'below_label' ? (
                <div
                    key={name + '.' + index}
                    className="ws-metaslot ws-metaslot-below-label"
                >
                    <FieldMetadata
                        metadataname={name}
                        metadatafield={field.metadata.get(name)}
                        worksheet={worksheet}
                    />
                </div>
            ) : null
        })
        BelowField = [...component.metadata].map(([name, value], index) => {
            return value === 'below_field' ? (
                <div
                    key={name + '.' + index}
                    className="ws-metaslot ws-metaslot-below-field"
                >
                    <FieldMetadata
                        metadataname={name}
                        metadatafield={field.metadata.get(name)}
                        worksheet={worksheet}
                    />
                </div>
            ) : null
        })
    }

    return (
        <LabeledField
            fieldgid={field.gid}
            editable={editable}
            hide_editable_icon={force_readonly}
            label={
                <FieldLabel
                    field={field}
                    inline
                    worksheet={worksheet}
                    metadata={component.metadata}
                />
            }
            fromClass={fromClass}
            worksheet={worksheet}
            {...attributes}
        >
            {BelowLabel}
            <div className="ws-placeholder-field">
                {Placeholder}
                {Field}
            </div>
            {BelowField}
        </LabeledField>
    )
})
